module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Oltingen-41af70b4b78110ee172ae787718bb74d.svg";